import React from 'react'
import styled from '@emotion/styled'
import { ThemeProvider } from '@emotion/react'
import { useEffect, useState } from 'react'
import mq from '../styles/mediaQueries'

import Logo from '../components/Logo'
import HamburgerSVG from '../assets/icons/hamburger.svg'

const dayTheme = {
  fontColor: 'var(--terminal-500)',
  borderColor: 'transparent',
  backgroundColor: 'transparent',
  position: 'absolute',
  boxShadow: 'unset',
}

const nightTheme = {
  fontColor: 'var(--terminal-0)',
  borderColor: 'transparent',
  backgroundColor: 'transparent',
  position: 'absolute',
  boxShadow: 'unset',
}

const stickyTheme = {
  fontColor: 'var(--terminal-0)',
  borderColor: 'var(--screen-400)',
  backgroundColor: 'var(--screen-400)',
  position: 'fixed',
  boxShadow:
    '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08), 0px 2px 24px rgba(0, 0, 0, 0.04)',
}

const overlayTheme = {
  fontColor: 'var(--terminal-0)',
  borderColor: 'var(--screen-400)',
  backgroundColor: 'transparent',
  position: 'fixed',
  boxShadow: 'unset',
}

const Hamburger = props => {
  return <HamburgerSVG {...props} style={{ display: 'block' }} />
}

const MobileMainNavBarWrapper = styled.div(props =>
  mq({
    display: props.invertedAbove
      ? 'none'
      : ['block', 'none', 'none', 'none', 'none'],
  })
)

const MobileNavBarWrapper = styled.div`
  height: 60px;
  inset: 12px 12px 0 12px;
  position: ${props => props.theme.position};
  width: calc(100vw - 24px);
  z-index: 10;
  background-color: ${props => props.theme.backgroundColor};
  border: 1px solid;
  border-color: ${props => props.theme.borderColor};
  box-shadow: ${props => props.theme.boxShadow};
`

const MobileNavBarHamburger = styled(Hamburger)`
  margin: 18px;
  pointer-events: auto;
  cursor: pointer;
  height: 24px;
  width: 24px;

  path {
    stroke: ${props => props.theme.fontColor};
  }
`

const MobileNavBarList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-block-end: 0;
`

const MobileNavBarListItem = styled.li`
  list-style: none;
`

const MobileNavBarHamburgerListItem = styled.li`
  list-style: none;
  display: inline-block;
  position: relative;
  z-index: 1;
  height: 60px;
  width: 60px;
  pointer-events: auto;
  cursor: pointer;
`

const MobileNavBarLogo = styled(Logo)`
  width: 120px;
  height: 17.88px;
  margin-right: 24px;

  path {
    fill: ${props => props.theme.fontColor};
  }
`

const MobileNavBarBackground = styled.div`
  position: fixed;
  background-color: var(--screen-500);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  opacity: ${props => (props.isOverlayOpen ? '1' : '0')};
  z-index: ${props => (props.isOverlayOpen ? '2' : '-10')};
  display: ${props => (props.isOverlayOpen ? 'block' : 'none')};
`

function MobileNavBar({ isOverlayOpen, toggleNav, theme, invertedAbove }) {
  const [prevScrollPos, setPrevScrollPos] = useState(0)
  const [visible, setVisible] = useState(true)
  const [detached, setDetached] = useState(true)
  const [colorTheme, setColorTheme] = useState(dayTheme)

  useEffect(() => {
    if (isOverlayOpen) {
      setColorTheme(overlayTheme)
    } else if (visible && !detached) {
      setColorTheme(stickyTheme)
    } else if (theme === 'night' || theme === 'blue') {
      setColorTheme(nightTheme)
    } else {
      setColorTheme(dayTheme)
    }
  }, [theme, isOverlayOpen, visible, detached])

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset
    setDetached(
      currentScrollPos <= 0 ||
        (currentScrollPos > 0 &&
          currentScrollPos <= 84 &&
          prevScrollPos < currentScrollPos)
    )
    setVisible(prevScrollPos > currentScrollPos)
    setPrevScrollPos(currentScrollPos)
  }

  useEffect(() => {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(handleScroll)
    })

    return () =>
      window.removeEventListener('scroll', () => {
        requestAnimationFrame(handleScroll)
      })
  }, [prevScrollPos, visible, handleScroll])

  return (
    <ThemeProvider theme={colorTheme}>
      <MobileMainNavBarWrapper invertedAbove={invertedAbove}>
        <MobileNavBarBackground isOverlayOpen={isOverlayOpen} />
        <MobileNavBarWrapper>
          <MobileNavBarList>
            <MobileNavBarHamburgerListItem onClick={toggleNav}>
              <MobileNavBarHamburger />
            </MobileNavBarHamburgerListItem>
            <MobileNavBarListItem>
              <MobileNavBarLogo alt="Logo" />
            </MobileNavBarListItem>
          </MobileNavBarList>
        </MobileNavBarWrapper>
      </MobileMainNavBarWrapper>
    </ThemeProvider>
  )
}

export default MobileNavBar
